import { all } from 'redux-saga/effects';

import RegisterSaga from './auth/register/saga';
import LoginSaga from './auth/login/saga';
import MerchantSaga from '../modules/merchants/store/saga/saga';
import ProfileSaga from './profile/saga';
import UtilSaga from './utils/saga';
import TransactionsSaga from '../modules/transactions/store/saga';
import CustomersSaga from './customers/saga';
import PaymentsSaga from './payment/saga';
// import PlansSaga from './plans/saga';
import PlansSaga from '../modules/recurring/store/plans/saga/saga';
import SettingsSaga from './settings/saga';
import InvoicesSaga from './invoice/saga';
import PayoutsSaga from './payouts/saga';
import OverviewSaga from './overview/saga';
import RecurringsSaga from '../modules/recurring/store/subscriptions/saga';
export default function* rootSaga() {
    yield all([
        MerchantSaga(),
        RegisterSaga(),
        LoginSaga(),
        ProfileSaga(),
        UtilSaga(),
        TransactionsSaga(),
        CustomersSaga(),
        PaymentsSaga(),
        PlansSaga(),
        SettingsSaga(),
        InvoicesSaga(),
        PayoutsSaga(),
        OverviewSaga(),
        RecurringsSaga()
    ]);
}
